import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './auth/auth.guard';

const routes: Routes = [
  { path: '', redirectTo: 'catalogs', pathMatch: 'full' },
  { path: 'auth', loadChildren: () => import('./auth/auth.module').then(m => m.AuthPageModule) },
  {
    path: 'catalogs',
    loadChildren: () => import('./catalogs/catalogs.module').then(m => m.CatalogsPageModule)
  },
  {
    path: 'establishments',
    loadChildren: () => import('./establisment/establishment.module').then(m => m.EstablishmentPageModule)
  },
  {
    path: 'promotions',
    loadChildren: () =>
      import('./promotions/promotions.module').then(
        m => m.PromotionsPageModule
      ),
    canLoad: [AuthGuard]
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./profile/profile.module').then(
        m => m.ProfilePageModule
      ),
    canLoad: [AuthGuard]
  },
  {
    path: 'config',
    loadChildren: () =>
      import('./config/config.module').then(
        m => m.ConfigPageModule
      ),
    canLoad: [AuthGuard]
  },
  {
    path: 'newsletters',
    loadChildren: () =>
      import('./newsletters/newsletters.module').then(
        m => m.NewslettersPageModule
      )
  },
  {
    path: 'loyalty-cards',
    loadChildren: () =>
      import('./loyalty-cards/loyalty-cards.module').then(
        m => m.LoyaltyCardsPageModule
      ),
    canLoad: [AuthGuard]
  },
  {
    path: 'policies',
    loadChildren: () =>
      import('./policies/policies.module').then(m => m.PoliciesPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
